import { PageTemplateContent } from 'app/common/templates-next/page-template'
import classNames from 'classnames/bind'

import { useCompensationBanace } from 'app/dataProviders/cafeteria/compensation/balance/hooks'
import { useFoodSuppliers } from 'app/dataProviders/cafeteria/compensation/foodSuppliers/hooks'
import { PlainColumns } from 'app/common/ui/PlainGrid'

import { CompensationInfoLoading } from './CompensationInfoLoading'
import { SupplierSelector } from '../SupplierSelector'
import { FoodSupplierInfo } from './components/FoodSupplierInfo'
import { BalanceInfo } from '../BalanceInfo/BalanceInfo'
import { CompensationAccountInfo } from './components/CompensationAccountInfo'

import styles from './CompensationInfo.scss'

const cx = classNames.bind(styles)

type Props = {
  studentID: string
  supplierID: string | null
  supplierSelectorLink: string
  withdrawToChildrenLink: string
  withdrawToParentLink: string
  returnLink: string
  onChangeSupplier: (supplierID: string) => void
}

export const CompensationInfo = ({
  studentID,
  supplierID,
  supplierSelectorLink,
  withdrawToChildrenLink,
  withdrawToParentLink,
  returnLink,
  onChangeSupplier,
}: Props) => {
  const { foodSuppliers, loading: loadingSuppliersInfo } = useFoodSuppliers({ studentID })
  const { balance, loading } = useCompensationBanace({ studentID, supplierID })
  const currentSupplierInfo = foodSuppliers.find((supplier) => supplier.ID === supplierID)

  if (!supplierID) {
    return (
      <SupplierSelector
        studentID={studentID}
        supplierID={supplierID}
        onChangeSupplier={onChangeSupplier}
        returnLink={returnLink}
        render={false}
      >
        <CompensationInfoLoading />
      </SupplierSelector>
    )
  }

  return (
    <PageTemplateContent>
      <FoodSupplierInfo
        supplierInfo={currentSupplierInfo}
        loading={loadingSuppliersInfo}
        link={supplierSelectorLink}
      />

      <PlainColumns className={cx(styles.row, styles.supplierSum)}>
        <BalanceInfo loading={loading} balance={balance} />

        <CompensationAccountInfo
          linkToChildrenAccount={withdrawToChildrenLink}
          linkToParentAccount={withdrawToParentLink}
          studentID={studentID}
          supplierID={supplierID}
        />
      </PlainColumns>
    </PageTemplateContent>
  )
}
